/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InsightsFormatPricingSchemaFormat = typeof InsightsFormatPricingSchemaFormat[keyof typeof InsightsFormatPricingSchemaFormat];


export const InsightsFormatPricingSchemaFormat = {
  pdf: 'pdf',
  csv: 'csv',
} as const;
